import { ActionPlugin } from '../Action/plugin'
import { ActionCallQueryNode } from './TypedNode'

import type { RehajePlugin } from '@rehaje/core'

export class ActionCallQueryPlugin implements RehajePlugin {
  constructor() {
    return new ActionPlugin({
      actions: {
        CallQuery: ActionCallQueryNode
      }
    })
  }
}
